import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SalonModel } from '../../models/SalonModel'

export interface SalonState {
    Salon: SalonModel
    SalonList: SalonModel[]
}

const initialState: SalonState = {
    Salon: {
        Id: 0,
        SalonCategoryId: 0,
        SalonCategoryName: '',
        SalonItem: '',
        GSTId: 0,
        GSTValue: '',
        Amount: 0
    },
    SalonList: [],
}

export const SalonSlice = createSlice({
    name: 'salon',
    initialState,
    reducers: {
        setSalons: (state, action: PayloadAction<SalonModel[]>) => {
            state.SalonList = action.payload
        },
        saveSalon: (state, action: PayloadAction<SalonModel>) => {
            let model = action.payload
            if (model.Id > 0) {
                let defaultModel: SalonModel = {
                    Id: model.Id,
                    SalonCategoryId: model.SalonCategoryId,
                    SalonCategoryName: model.SalonCategoryName,
                    SalonItem : model.SalonItem,
                    GSTId: model.GSTId,
                    GSTValue: model.GSTValue,
                    Amount: model.Amount
                }
                let currentModel = state.SalonList.find((c) => c.Id === model.Id) || defaultModel
                currentModel.SalonCategoryId = model.SalonCategoryId
                currentModel.SalonCategoryName = model.SalonCategoryName
                currentModel.SalonItem = model.SalonItem
                currentModel.GSTId = model.GSTId
                currentModel.GSTValue= model.GSTValue
                currentModel.Amount = model.Amount
            } else {
                model.Id = (Math.max(...state.SalonList.map((c) => c.Id)) || 0) + 1
                state.SalonList.push(model)
            }
        },
        getSalonById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let model: SalonModel = initialState.Salon
            if (id > 0) {
                let currentList: SalonModel[] = state.SalonList
                model = currentList.find((c) => c.Id === id) || initialState.Salon
            }

            state.Salon = model
        },
        deleteSalon: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentList: SalonModel[] = state.SalonList
                state.SalonList = currentList.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setSalons, saveSalon, getSalonById, deleteSalon } =
    SalonSlice.actions

export default SalonSlice.reducer
